module.exports = __webpack_public_path__ + "img/default_product.b7a9311.jpg";